module.exports = __webpack_public_path__ + "img/tooltiparw.0c1b3fed.svg";